module.exports = __webpack_public_path__ + "img/sort.9a0de910.svg";